module.exports = __webpack_public_path__ + "img/homepageVector.23acb12e.png";